import { v4 as uuid } from "uuid"
import ActionTypes from "../../enums/ActionTypes"
import MessageTypes from "../../enums/MessageTypes"

type SnackbarValues = Record<string, unknown>

export function createSnackbarMessage(
  type: MessageTypes,
  text: string,
  values?: SnackbarValues,
  defaultMessage?: string
) {
  const id = uuid()

  return {
    type: ActionTypes.SNACKBAR_MESSAGE_CREATE,
    payload: { text, id, values, defaultMessage, type },
  }
}

export function removeSnackbarMessage(id: string) {
  return {
    type: ActionTypes.SNACKBAR_MESSAGE_REMOVE,
    payload: { id },
  }
}
